import React from 'react';
import { Outlet } from 'react-router-dom';

const AuthLayout: React.FC = () => {
  return (
    <div className="authpage-bg flex items-center justify-center min-h-screen p-4 relative">
      <div className="w-full max-w-[568px]">
        <Outlet />
      </div>
      <span className="absolute left-[16px] bottom-[16px] text-[16px] text-[#666666]">
        ©2025 All rights reserved.
      </span>
    </div>
  );
};

export default AuthLayout;

